export function asArray(any){
    return Array.isArray(any) ? any : [];
}